import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import AdminSubpage from '../components/AdminSubpage';
import { closetAPI } from '../services/api';

const emptyBank = () => ({
  bank_name: '',
  bank_account_holder: '',
  bank_iban: '',
  bank_account_number: '',
  bank_swift_code: '',
});

const InfluencerBankDetailsPage = () => {
  const [form, setForm] = useState(emptyBank());
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      try {
        const res = await closetAPI.getMyBankDetails();
        const d = res.data?.bank_details || {};
        if (!cancelled) {
          setForm({
            bank_name: d.bank_name || '',
            bank_account_holder: d.bank_account_holder || '',
            bank_iban: d.bank_iban || '',
            bank_account_number: d.bank_account_number || '',
            bank_swift_code: d.bank_swift_code || '',
          });
        }
      } catch (error) {
        if (!cancelled) {
          toast.error(error.response?.data?.message || error.message);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await closetAPI.updateMyBankDetails(form);
      toast.success('Bank details saved');
    } catch (error) {
      toast.error(error.response?.data?.message || error.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <AdminSubpage title="Bank details" backTo="/products">
      {loading ? (
        <div className="loading">Loading…</div>
      ) : (
        <div className="admin-page-panel modal-content" style={{ maxWidth: 560 }}>
          <p style={{ marginBottom: 16, color: '#666' }}>
            Payout details for your closet sales. Only admins can view this information.
          </p>
          <form onSubmit={submit}>
            <div className="form-group">
              <label>Bank name</label>
              <input
                type="text"
                value={form.bank_name}
                onChange={(e) => setForm({ ...form, bank_name: e.target.value })}
              />
            </div>
            <div className="form-group">
              <label>Account holder name</label>
              <input
                type="text"
                value={form.bank_account_holder}
                onChange={(e) => setForm({ ...form, bank_account_holder: e.target.value })}
              />
            </div>
            <div className="form-group">
              <label>IBAN</label>
              <input
                type="text"
                value={form.bank_iban}
                onChange={(e) => setForm({ ...form, bank_iban: e.target.value })}
              />
            </div>
            <div className="form-group">
              <label>Account number</label>
              <input
                type="text"
                value={form.bank_account_number}
                onChange={(e) => setForm({ ...form, bank_account_number: e.target.value })}
              />
            </div>
            <div className="form-group">
              <label>SWIFT / BIC</label>
              <input
                type="text"
                value={form.bank_swift_code}
                onChange={(e) => setForm({ ...form, bank_swift_code: e.target.value })}
              />
            </div>
            <div className="form-actions">
              <button type="submit" className="btn btn-primary" disabled={saving}>
                {saving ? 'Saving…' : 'Save bank details'}
              </button>
            </div>
          </form>
        </div>
      )}
    </AdminSubpage>
  );
};

export default InfluencerBankDetailsPage;
